import React, { useEffect, useRef, useState } from 'react';
import api from '../services/api';
import { useOrcamentoFeedback } from './OrcamentoUI';

export default function ManutencaoLinkExterno({ obraId, posicao, onClose }) {
    const { confirm } = useOrcamentoFeedback();
    const [acesso, setAcesso] = useState(null);
    const [busy, setBusy] = useState(true);
    const [error, setError] = useState('');
    const [feedback, setFeedback] = useState('');
    const input = useRef(null);
    const pending = useRef(false);
    const endpoint = `/manutencao/obras/${obraId}/acesso-externo`;
    const url = acesso?.ativo ? `${window.location.origin}/manutencao/externo/${acesso.token}` : '';
    useEffect(() => {
        let mounted = true;
        api.get(endpoint).then(r => { if (mounted) setAcesso(r.data); })
            .catch(e => { if (mounted) setError(e.response?.data?.error || 'Não foi possível consultar o acesso. Feche e tente novamente.'); })
            .finally(() => { if (mounted) setBusy(false); });
        return () => { mounted = false; };
    }, [endpoint]);
    const alterar = async acao => {
        if (pending.current) return;
        pending.current = true;
        try {
            if (acao !== 'gerar' && !(await confirm(acao === 'revogar'
                ? 'Desativar o acesso do técnico a esta ordem? O link deixará de funcionar.'
                : 'Substituir o link? O anterior deixará de funcionar.'))) return;
            setBusy(true); setError(''); setFeedback('');
            if (acao === 'revogar') {
                await api.delete(endpoint);
                setAcesso({ ativo: false, token: null });
                setFeedback('Link desativado.');
            } else {
                const r = await api.post(endpoint, { substituir: acao === 'substituir' });
                setAcesso(r.data);
                setFeedback(acao === 'substituir' ? 'Novo link criado. O anterior foi desativado.' : 'Link criado. Pode copiá-lo e enviá-lo ao técnico.');
            }
        } catch (e) { setError(e.response?.data?.error || 'Não foi possível alterar o acesso. Tente novamente.'); }
        finally { pending.current = false; setBusy(false); }
    };
    const copiar = async () => {
        try {
            if (!navigator.clipboard?.writeText) throw new Error('Cópia manual');
            await navigator.clipboard.writeText(url);
            setFeedback('Link copiado.');
        } catch {
            input.current?.focus(); input.current?.select();
            setFeedback('Selecione o endereço e copie manualmente.');
        }
    };
    return (
        <div className="modal-ef mnt-modal mnt-link-dialog" onClick={e => e.stopPropagation()}>
            <div className="modal-ef-header">
                <h3>Link para técnico externo</h3>
            </div>
            <div className="mnt-modal-body">
            <p className="mnt-link-order">Ordem {posicao}</p>
            <p className="mnt-link-description">Quem tiver este link pode preencher fichas desta ordem, juntar fotografias e recolher assinaturas, sem conta.</p>
            {busy && <p role="status">A atualizar o acesso…</p>}
            {error && <p role="alert" style={{ color: '#a33445' }}>{error}</p>}
            {feedback && <p role="status" className="mnt-link-feedback">{feedback}</p>}
            {url && <label className="mnt-link-field">Link desta ordem
                <input ref={input} aria-label="Link desta ordem" readOnly value={url} onFocus={e => e.target.select()} style={{ width: '100%', boxSizing: 'border-box', padding: 12, marginTop: 6, font: 'inherit', border: '1px solid #cbd5e1', borderRadius: 8 }} />
            </label>}
            {acesso && <div className="mnt-link-actions">
                {url ? <>
                    <button type="button" className="mnt-btn mnt-primary" disabled={busy} onClick={copiar}>Copiar link</button>
                    <button type="button" className="mnt-btn mnt-secondary" disabled={busy} onClick={() => alterar('substituir')}>Substituir link</button>
                    <button type="button" className="mnt-btn mnt-secondary mnt-danger" disabled={busy} onClick={() => alterar('revogar')}>Desativar link</button>
                </> : <button type="button" className="mnt-btn mnt-primary" disabled={busy} onClick={() => alterar('gerar')}>Gerar link</button>}
            </div>}
            </div>
            <div className="modal-form-actions">
                <button type="button" className="mnt-btn mnt-secondary" disabled={busy} onClick={onClose}>Fechar</button>
            </div>
        </div>
    );
}
